import * as React from "react";

import { BaseTile } from "Components/BaseTile";
import { CoopBenefits } from "Components/Partner/CoopBenefits/CoopBenefits";

import { AlternativeProductLogin } from "../AlternativeProductLogin";

import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { ReduxState } from "Store/rootReducer";
import { useABTestingFeature } from "Utils/unleash/flagHooks";
import { FeatureFlagABTest } from "Utils/unleash/flags";
import { useSelector } from "react-redux";
import { DefaultLogin } from "../DefaultLogin";

interface Props {
  productBackendName: ProductBackendName;
}

export const ChildLogin = ({
  productBackendName,
}: Props): React.ReactElement => {
  const { userIdentification } = useSelector((state: ReduxState) => state);
  const validNameNin = userIdentification.current?.newCustomerResponse?.isValid;

  if (useABTestingFeature(FeatureFlagABTest.SSX_1646_ALTERNATIVE_CHILD_LOGIN)) {
    return <AlternativeProductLogin productBackendName={productBackendName} />;
  }

  return (
    <BaseTile>
      <DefaultLogin
        productBackendName={productBackendName}
        validNameNin={validNameNin}
        isLoading={userIdentification.isLoading}
      />
      <CoopBenefits />
    </BaseTile>
  );
};
